module.exports = __webpack_public_path__ + "images/business-class-feature-roadmap.0f99b85b579fc74b3199.png";